import initialStateLoader from '../initialState';

const SET_SEGMENT = 'huggg/selected-segment/SET_SEGMENT';
const CLEAR_SEGMENT = 'huggg/selected-segment/CLEAR_SEGMENT';

const { selectedSegment: initialState } = initialStateLoader();

/* Reducer - Default Export
========================================================================== */
const reducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {

        case SET_SEGMENT:
            return {
                ...state,
                segment: payload.segment,
            };

        case CLEAR_SEGMENT:
            return {
                ...state,
                segment: null,
            };

        default:
            return state;
    }
};

export default reducer;


/* Actions
========================================================================== */
export const setSelectedSegment = segment => dispatch => {
    dispatch({ type: SET_SEGMENT, payload: { segment } });
}
export const clearSelectedSegment = () => dispatch => dispatch({ type: CLEAR_SEGMENT });

/* Selectors
========================================================================== */

export const getIsFormRedemptionType = state => state.selectedSegment?.segment?.voucherType === 'form-redemption';
export const getIsPin4Type = state => state.selectedSegment?.segment?.voucherType === 'pin4';
export const getIsPrepaidCardType = state => state.selectedSegment?.segment?.voucherType === 'prepaid-card';
export const getDefaultSegmentTerritory = state => state.selectedSegment?.segment?.territories?.length === 1 ? state.selectedSegment?.segment?.territories[0].countryIso : undefined
export const getSelectedSegment = state => state.selectedSegment.segment;

export const actions = {
    setSelectedSegment,
    getSelectedSegment,
    clearSelectedSegment,
    getDefaultSegmentTerritory,
    getIsFormRedemptionType,
    getIsPin4Type,
    getIsPrepaidCardType,
};
